import formulario from "../lib/formulario";
var pregunta = function (pregunta, onAcertada) {
    var _a = JSON.parse(pregunta.dataset.pregunta), correcta = _a.correcta, explicacion = _a.explicacion, datos = _a.datos;
    var botones = Array.from(pregunta.querySelectorAll('button'));
    var acertada = false;
    var informacionMostrada = false;
    var abreInformacion = function () {
        informacionMostrada = true;
        var contenedorExplicacion = document.createElement('div');
        contenedorExplicacion.classList.add('trivial__explicacion');
        contenedorExplicacion.innerHTML = "\n                    <div class=\"trivial__explicacion__contenido\" id=\"explicacion\">\n                        <button aria-controls=\"explicacion\">X</button>\n                        <h3>".concat(explicacion.titulo, "</h3>\n                        <div>").concat(explicacion.texto, "</div>\n                    </div>\n                ");
        var cierraExplicacion = function () {
            contenedorExplicacion.classList.remove('is-visible');
            contenedorExplicacion.addEventListener('transitionend', function () {
                contenedorExplicacion.remove();
            }, { once: true });
            pregunta.classList.remove('is-girada');
            informacionMostrada = false;
        };
        contenedorExplicacion.querySelector('button').addEventListener('click', cierraExplicacion);
        document.documentElement.appendChild(contenedorExplicacion);
        requestAnimationFrame(function () {
            contenedorExplicacion.classList.add('is-visible');
        });
        contenedorExplicacion.addEventListener('click', function (e) {
            if (e.target === contenedorExplicacion) {
                cierraExplicacion();
            }
        });
    };
    botones.forEach(function (boton, index) {
        boton.addEventListener('click', function () {
            if (informacionMostrada) {
                return;
            }
            if (acertada) {
                if (index == correcta) {
                    abreInformacion();
                }
                return;
            }
            acertada = index === correcta;
            if (acertada) {
                boton.classList.add('is-correcta');
                onAcertada();
                abreInformacion();
            }
            else {
                boton.classList.add('is-incorrecta');
                setTimeout(function () {
                    boton.classList.remove('is-incorrecta');
                }, 1000);
            }
        });
    });
};
var ocultaBloques = function (bloquesOcultos) {
    var bloques = Array.from(document.querySelectorAll('.bloque'));
    bloquesOcultos.forEach(function (x) { return bloques[x].style.display = 'none'; });
};
var muestraBloques = function (bloquesVisibles) {
    if (bloquesVisibles.length === 0) {
        return;
    }
    var bloques = Array.from(document.querySelectorAll('.bloque'));
    bloquesVisibles.forEach(function (x) { return bloques[x].style.display = 'block'; });
    requestAnimationFrame(function () {
        var bloque = bloques[bloquesVisibles[0]];
        var top = bloque.getBoundingClientRect().top;
        var scrollY = window.scrollY;
        window.scrollTo(0, top + scrollY - 100);
    });
};
var ocultaTarjetas = function (preguntas) { return preguntas.forEach(function (p) { return p.classList.remove('is-girada'); }); };
var giraTarjeta = function (preguntas, index) {
    ocultaTarjetas(preguntas);
    preguntas[index].classList.add('is-girada');
};
var tarjetas = function (preguntas, onCompletado) {
    var enlaces = preguntas.map(function (x) { return x.querySelector('a'); });
    // Eliminamos el retraso que se usa para cuando caen las tarjetas, para que no tarden al girar
    preguntas.forEach(function (pregunta) { return pregunta.addEventListener('transitionend', function () {
        pregunta.style.transitionDelay = '0s';
    }, { once: true }); });
    enlaces.forEach(function (enlace, index) { return enlace.addEventListener('click', function (e) {
        e.preventDefault();
        giraTarjeta(preguntas, index);
    }); });
    var correctas = 0;
    preguntas.forEach(function (x) { return pregunta(x, function () {
        correctas += 1;
        if (correctas === preguntas.length) {
            onCompletado();
        }
    }); });
};
var trivial = function () {
    var dataLayer = window.dataLayer;
    Array.from(document.querySelectorAll('.bloque--trivial')).forEach(function (bloque) {
        var _a;
        var form = bloque.querySelector('.trivial__formulario');
        var contenedor = bloque.querySelector('.trivial__preguntas');
        contenedor.style.display = 'none';
        //form.style.display = 'none';
        formulario("#".concat(bloque.id, " form"), {
            dataLayer: dataLayer,
            ocultarEtiquetas: true,
            enviado: function () {
                form.style.display = 'none';
                contenedor.style.display = 'grid';
            }
        });
        var preguntas = Array.from(contenedor.querySelectorAll('.trivial__pregunta'));
        var bloquesOcultos = ((_a = contenedor.dataset.bloquesOcultos) === null || _a === void 0 ? void 0 : _a.split(',').map(function (x) { return parseInt(x) - 1; })) || [];
        // Ocultamos los bloques que se deban ocultar al iniciar el trivial
        ocultaBloques(bloquesOcultos);
        // Gestionamos los clics fuera de las tarjetas, para ocultar la tarjeta activa
        bloque.addEventListener('click', function (e) {
            var target = e.target;
            if (!target.closest('.trivial__pregunta')) {
                ocultaTarjetas(preguntas);
            }
        });
        // Tras responder todas las preguntas, mostramos los bloques que estaban ocultos
        tarjetas(preguntas, function () { return muestraBloques(bloquesOcultos); });
        contenedor.classList.add('is-inicializada');
    });
};
export default trivial;
